export default function IconA1() {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1272_65109)">
                <path
                    d="M24.0625 5.25H3.9375C3.21263 5.25 2.625 5.83763 2.625 6.5625V18.8125C2.625 19.5374 3.21263 20.125 3.9375 20.125H24.0625C24.7874 20.125 25.375 19.5374 25.375 18.8125V6.5625C25.375 5.83763 24.7874 5.25 24.0625 5.25Z"
                    stroke="black"
                    strokeWidth="1.05"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M2.625 16.625H25.375" stroke="black" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.375 22.75H16.625" stroke="black" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 22.75L14 20.125" stroke="black" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1272_65109">
                    <rect width="28" height="28" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
